import { BALANCE } from '../balance';
import type { RoomId } from '../ids';
import type { RewardInput } from '../schemas/progression';

/**
 * Coziness level rewards (content-schemas §8.1, economy §6). Thresholds come from balance.cozinessLevels;
 * this file only pairs each level with its rewards.
 */
const STARS = { type: 'stars', amount: BALANCE.starsPer.cozinessLevel } as const;

export const COZINESS_REWARDS: Record<RoomId, readonly (readonly RewardInput[])[]> = {
  home: [
    [STARS, { type: 'coins', amount: 20 }],
    [STARS, { type: 'npcVisit', npcId: 'npc_lan', roomId: 'home' }],
    [STARS, { type: 'coins', amount: 60 }],
    [
      STARS,
      { type: 'npcVisit', npcId: 'npc_mit', roomId: 'home' },
      { type: 'npcVisit', npcId: 'npc_boss_cat', roomId: 'home' },
    ],
    [STARS, { type: 'title', titleId: 'ttl_cozy_home_5' }, { type: 'photoFrame', frameId: 'frm_home_lv5' }],
  ],
  minimart: [
    [STARS, { type: 'shopPerk', perkId: 'faster_customers' }],
    [STARS, { type: 'coins', amount: 30 }],
    [STARS, { type: 'shopPerk', perkId: 'regulars_buy_more' }],
    [STARS, { type: 'coins', amount: 80 }],
    [STARS, { type: 'title', titleId: 'ttl_cutest_shop' }],
  ],
  studio: [],
};
